Ext.define('SA.data.quickreport.QuickReportDataResult', {
    singleton: true,

    async build(templateItem, locations, values) {
        var sections = templateItem.getSections();

        await this.cacheAttributes(templateItem.getAttributes());

        return {
            firstColSections: sections,

            bodyColumns: locations.map(location => {
                return {
                    locationSeries: location,
                    sections: mapSectionsToBodyColumnSections(location, sections)
                };
            }),

            headerItems: locations.map(location => {
                var locationItem = SA.data.LocationsCache.get(location);

                return {
                    alias: locationItem.locationAlias,
                    locationSeries: location,
                    name: locationItem.name,
                    type: this.getLocationTypeText(locationItem)
                };
            })
        };

        function mapSectionsToBodyColumnSections(location, sections) {
            return sections.map(section => {
                var [headerLeft, headerRight] = section.attributeHeaders;

                return {
                    hasHeaders: headerLeft || headerRight,
                    headerLeft,
                    headerRight,

                    rows: section.attributeTuples.map(tuple => {
                        return {
                            cellPairs: mapTupleAttributesToCellPairs(tuple.attributes)
                        };
                    })
                };
            });

            function mapTupleAttributesToCellPairs(attributes) {
                return attributes.map((attribute, index) => {
                    return {
                        attribute,
                        formattedValue: attribute ? getFormattedValue(location, attribute) : null,
                        isAmount: index === 0,
                        locationSeries: location
                    };
                });
            }
        }

        function getFormattedValue(location, attribute) {
            var Attributes = SA.data.AttributesCache,
                value = values[location][attribute];

            return Attributes.formatValue(value, Attributes.get(attribute).formatString);
        }
    },

    cacheAttributes(attributes) {
        return new Promise(resolve => {
            maybeResolve();

            function maybeResolve() {
                if (SA.data.AttributesCache.get(attributes, maybeResolve).every(Ext.identityFn)) {
                    resolve();
                }
            }
        });
    },

    getLocationTypeText(locationItem) {
        var isCombo = locationItem.type === 'combination',
            isRadius = locationItem.type === 'radius',
            text;

        if (isCombo) {
            text = getComboLocationTypeText(locationItem);
        }
        else if (isRadius) {
            text = 'Radius Location around a ' + getUnit(locationItem).singularName;
        }
        else {
            text = getUnit(locationItem).singularName;
        }

        return text;

        function getComboLocationTypeText(locationItem) {
            var firstLocation = SA.data.LocationsCache.get(locationItem.locationSeries[0]),
                unit = getUnit(firstLocation);

            return 'Combination Location: ' + unit.name;
        }

        function getUnit(location) {
            return SA.data.GeographicUnits.get(location.geographicUnit);
        }
    }
});